module.exports = __webpack_public_path__ + "img/5.3264a4ef.webp";